/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './tableHeaders/attendee';
import { GET } from '/client/src/api';
import _ from 'lodash';

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

type PropsType = {
  eventId: string,
  onHandleSelectRow: () => void,
  selected: []
};

const AttendeeBody = ({ eventId, onHandleSelectRow, selected }: PropsType): React.Element<'div'> => {
  const [data, setData] = React.useState([]);
  const [pending, setPending] = React.useState(true);
  const [search, setSearch] = React.useState('');

  const CustomLoader = (): React.Element<'div'> => (
    <div className='csspinner' style={{ width: '50px', height: '50px' }} />
  );

  let __data = data;

  if (__data && _.size(search)) {
    __data = _.filter(__data, (d: {}): any => {
      return d.first_name && d.first_name.indexOf(search) > -1 ||
        d.last_name && d.last_name.indexOf(search) > -1 ||
        d.order.creation_time && d.order.creation_time.indexOf(search) > -1 ||
        d.email_address && d.email_address.indexOf(search) > -1 ||
        d.phone_number && d.phone_number.indexOf(search) > -1;
    });
  }

  const _setSearch = (e: any): void => setSearch(e.target.value);

  const fetchData =  async () => {
    try {
      // eslint-disable-next-line
      const { result } = await GET(`/api/v1/1/events/${eventId}/attendees?max_result_count=500&skip_count=0&sorting=order.paid_time_utc+desc`);

      setData(result.items);
      setPending(false);
    } catch (e) {
      console.log(e);
      console.error('Cant get attendees');
      setPending(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [eventId]);

  return (
    <div className="panel-body" style={{ padding: '15px 0' }}>
      <div className="form-group">
        <div className="input-group event-search">
          <input
            className="form-control"
            style={{ textAlign: 'left' }}
            type="text"
            placeholder="search guests"
            value={search}
            onChange={_setSearch}
          />
          <span className="input-group-btn">
            <button
              className="btn btn-default btn-search"
              type="button"
            >
              <span className="icon icon-search" />
            </button>
          </span>
        </div>
      </div>

      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <DataTable
            columns={columns}
            data={__data}
            customStyles={customStyles}
            highlightOnHover
            responsive
            striped
            fixedHeader
            noHeader
            progressPending={pending}
            progressComponent={<CustomLoader />}
            selectableRows
            onSelectedRowsChange={(selected: any) => {
              onHandleSelectRow(selected.selectedRows);
            }}
            selectableRowSelected={(row) => selected.includes(row.user_id || row.id)}
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendeeBody;
